/**
 * Free Shipping Progress Bar
 * Fetches cart data and updates the shipping bar UI.
 * Threshold is passed via data attribute from Liquid (settings.pp_shipping_threshold).
 */
class FreeShippingBar {
  constructor() {
    this.threshold = 0;
    this.initialized = false;
    this.init();
  }

  init() {
    this.bars = document.querySelectorAll('.pp-shipping-bar');
    if (!this.bars.length) return;

    this.threshold = this.getThreshold();
    this.update();

    if (!this.initialized) {
      this.listen();
      this.initialized = true;
    }
  }

  getThreshold() {
    const bar = this.bars[0];
    const val = parseFloat(bar.dataset.threshold);
    return isNaN(val) ? 50 : val;
  }

  async update() {
    // Re-query in case drawer was just opened
    this.bars = document.querySelectorAll('.pp-shipping-bar');
    if (!this.bars.length) return;
    if (!this.threshold) this.threshold = this.getThreshold();

    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();
      const totalDollars = cart.total_price / 100;
      this.render(totalDollars);
    } catch (e) {
      // silently fail
    }
  }

  render(total) {
    const threshold = this.threshold;
    const remaining = Math.max(threshold - total, 0);
    const pct = threshold > 0 ? Math.min((total / threshold) * 100, 100) : 100;
    const reached = remaining <= 0;
    const close = !reached && pct >= 80;

    let message;
    if (reached) {
      message = '\uD83C\uDF89 You\u2019ve unlocked free shipping!';
    } else if (close) {
      message = 'Almost there! Just $' + remaining.toFixed(2) + ' more for free shipping!';
    } else {
      message = 'You\u2019re $' + remaining.toFixed(2) + ' away from free shipping!';
    }

    this.bars.forEach(function (bar) {
      var fill = bar.querySelector('.pp-shipping-bar__fill');
      var text = bar.querySelector('.pp-shipping-bar__text');
      if (fill) fill.style.width = pct + '%';
      if (text) {
        text.textContent = message;
        if (reached) {
          text.classList.add('pp-shipping-bar__text--reached');
        } else {
          text.classList.remove('pp-shipping-bar__text--reached');
        }
      }
    });
  }

  listen() {
    var self = this;

    // Listen for Dawn's cart update events
    document.addEventListener('cart:refresh', function () { self.update(); });

    // Observe DOM mutations on cart count bubble as a fallback
    var bubble = document.querySelector('.cart-count-bubble');
    if (bubble) {
      var observer = new MutationObserver(function () { self.update(); });
      observer.observe(bubble, { childList: true, subtree: true, characterData: true });
    }

    // Re-init when cart drawer opens (details toggle or class change)
    document.addEventListener('click', function (e) {
      if (e.target.closest('#cart-icon-bubble, .cart-drawer__overlay, cart-drawer')) {
        setTimeout(function () { self.init(); }, 100);
      }
    });

    // Intercept fetch to /cart/ endpoints
    var original = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var result = original.apply(this, args);
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      if (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/clear') !== -1) {
        result.then(function () {
          setTimeout(function () { self.update(); }, 300);
        });
      }
      return result;
    };
  }
}

// Initialize on DOMContentLoaded and also after a short delay for dynamic content
document.addEventListener('DOMContentLoaded', function () {
  window.ppShippingBar = new FreeShippingBar();
});
